import { Loader2 } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface SpinnerProps {
  className?: string;
}

export function Spinner({ className }: SpinnerProps) {
  return (
    <Loader2
      className={twMerge(
        "mx-auto size-6 animate-spin text-[#1884F9]",
        className,
      )}
    />
  );
}
